






































































































import Vue from 'vue'
import EditTenant from './components/EditTenant.vue'
import CreateTenant from './components/CreateTenant.vue'
import TenantAuthSettings from './components/TenantAuthSettings.vue'
import { columns } from './components/custom'
import {
  MasterlinkTenantServiceProxy,
  DictServiceProxy,
  ROfListOfDict
} from '@/service-proxies/app-v2/system.service-proxies'

const TenantService = new MasterlinkTenantServiceProxy()
const DictService = new DictServiceProxy()

export default Vue.extend({
  name: '',
  components: {
    EditTenant,
    CreateTenant,
    TenantAuthSettings
  },
  data() {
    return {
      dataSource: [],
      totalContent: 0, // 表单列表数
      selectedRow: {}, // 编辑数据
      RowKey: '', // 所选表单行
      showTenantDetail: false,
      showCreateTenant: false,
      showAuthSettings: false,
      filter: {
        // 查询条件
        size: 30,
        current: 1,
        tenantInfo: ''
      },
      tenantClasses: []
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      if (document.body.clientHeight < 800) {
        this.filter.size = 30
      }
      this.getList()

      DictService.dictionary('audience_category').then((res: ROfListOfDict) => {
        const HOST_DICT_KEY = '1'
        if (res.data) {
          this.tenantClasses = []
          const dicArray = res.data

          dicArray.forEach((element) => {
            // remove host dictionary item
            if (element.dictKey !== HOST_DICT_KEY) {
              const dic = { key: element.dictValue, value: element.dictKey }
              this.tenantClasses.push(dic)
            }
          })
        }
      })
    },
    getList() {
      TenantService.getTenants(
        undefined,
        this.filter.current,
        this.filter.size,
        undefined,
        this.filter.tenantInfo
      ).then((res: any) => {
        if (res.data.records) {
          this.totalContent = res.data.total
          // this.dataSource = res.data.records
          
          let dataLength = res.data.records.length;
          let copy = JSON.parse(JSON.stringify(res.data.records));
          let needPush = 0;
          if(dataLength < 30) {
            needPush = 30 - dataLength;
            for(var k=0; k<needPush; k++) {
              let obj = {  
                // id: 'none'
              }
              copy.push(obj)  
            }
          }
          
          this.dataSource = JSON.parse(JSON.stringify(copy));


        }
      })
    },
    rowClick(record: any) {
      return {
        on: {
          click: (event: any) => {
            this.showTenantDetail = true
            this.RowKey = record.id
            this.selectedRow = record
          }
        }
      }
    },
    handleEdit(record: any) {
      if (this.showTenantDetail) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.showTenantDetail = true
            this.RowKey = record.id
            this.selectedRow = record
          },
          onCancel() {
            return
          }
        })
      } else {
        this.showTenantDetail = true
        this.RowKey = record.id
        this.selectedRow = record
      }
    },
    closemodal(e: boolean) {
      this.showTenantDetail = false
      this.showCreateTenant = false
      this.showAuthSettings = false
      if (e) {
        this.load()
      }
    },
    onCreateTenant() {
      this.showCreateTenant = true
    },
    onDelete(id: string) {
      TenantService.deleteTenant(id).then((res: any) => {
        this.$message.success(this.$t('page_tenant_deleted'))
        this.load()
      })
    },
    onTenantAuthSetting(record: any) {
      this.showAuthSettings = true
      this.selectedRow = record
    },
    handlesearch(value: any) {
      this.filter.tenantInfo = value
      this.pageIndexchange(1)
    },
    pageIndexchange(current: any) {
      this.filter.current = current
      this.getList()
    }
  }
})
